import { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

// Post-login router. Sends admin-tier roles to /admin, creators to /creator.
// Kept as a stable entry point for the OAuth `redirect=/dashboard` URL.
// 2026-07-28 — creator default landing moved from /portal to /creator
// (the new unified back-office dashboard). /portal remains reachable from it.
const ADMIN_TIER = new Set([
  "super_admin", "admin", "manager", "support", "finance", "read_only",
]);

export default function Dashboard() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  const isAdmin = ADMIN_TIER.has(user?.role);

  useEffect(() => {
    if (loading) return;
    if (!user) navigate("/login", { replace: true });
    else if (isAdmin) navigate("/admin", { replace: true });
    else navigate("/creator", { replace: true });
  }, [user, loading, navigate, isAdmin]);

  if (!user) return null;
  if (isAdmin) return <Navigate to="/admin" replace />;
  return <Navigate to="/creator" replace />;
}
